import { Route, Routes } from 'react-router-dom'
import { aliasMapAuth, getComponentAuth } from '../routers/AuthRouter'
import NothingHere from '../pages/error/NothingHere'

export default function PublicRouter () {
    return (
        <div className="contenedor-full vh-100">
            <Routes>
                {Object.entries(aliasMapAuth).map(([alias, path]) => (
                    <Route key={alias} path={alias} element={getComponentAuth(path)} />
                ))}
                <Route path="/nothinghere" element={<NothingHere />} />
                <Route path="*" element={<NothingHere />} />
            </Routes>
        </div>
    )
}